import { Injectable } from '@angular/core';
import { SmsLog } from '@osos/shared/api';
import { SMSLogPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../../bases/parser/parser-base';

@Injectable()
export class SmsParserV1Service extends ParserBase<
  SmsLog,
  SMSLogPresenterModel
> {
  constructor() {
    super(SmsLog, SMSLogPresenterModel, 1);
  }

  getPresenterModel(model: Partial<SmsLog>): SMSLogPresenterModel {
    return {
      id: model.id,
      to: model.to,
      body: model.body,
      messageId: model.messageId,
      generatedAt: model.generatedAt,
      timestamp: model.timestamp,
      status: 'success',
      strategy: model.strategy,
      errorMessage: model.errorMessage,
      smsProviderResponse: model.smsProviderResponse,
      relatedTriggerExecutionId: model.relatedTriggerExecutionId,
    };
  }

  getDataModel(presenter: SMSLogPresenterModel): SmsLog {
    return {
      id: presenter.id,
      to: presenter.to,
      body: presenter.body,
      messageId: presenter.messageId,
      generatedAt: presenter.generatedAt,
      timestamp: presenter.timestamp,
      status: presenter.status,
      strategy: presenter.strategy,
      errorMessage: presenter.errorMessage,
      smsProviderResponse: presenter.smsProviderResponse,
      relatedTriggerExecutionId: presenter.relatedTriggerExecutionId,
    };
  }
}
